import React from 'react'

const StuiDivider: React.SFC<{}> = () => <div className="o-stui-divider" />

export default StuiDivider
